import React, { useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import {
  DefaultButton,
  DefaultPrimaryButton,
  InputWithLabel,
} from "../../components/micro/input";
import ConfirmationModel from "../../components/common/ConfirmationModel";
import { useDispatch } from "react-redux";
import { createCategories } from "../../redux/categories/slice";
import Breadcrumb from "../../components/common/BreadCrumb";

const CreateEditCategory = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isEditMode = location?.state?.mode;
  const [isEditing, setIsEditing] = useState(false);
  const [formValues, setFormValues] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDisable, setIsDisable] = useState(true);

  const categoryData = location?.state?.category;

  const handleConfirm = async () => {
    setIsLoading(true);

    const payload = {
      name: formValues.categoryName,
    };

    const action = categoryData?.id
      ? createCategories({ id: categoryData.id, ...payload })
      : createCategories(payload);

    try {
      const res = await dispatch(action);
      if (res.type === "createCategories/fulfilled") {
        navigate("/product-categories");
      }
    } catch (error) {
      console.error("Error creating product:", error);
    } finally {
      setIsLoading(false);
      setShowConfirmationModal(false);
    }
  };

  const handleEditClick = () => {
    setIsEditing(true);
  };

  return (
    <>
      <div className="mb-3">
        <div>
          <h6 className="font-Montserrat font-medium text-xl mb-3">
            {isEditMode == "edit" ? "Edit Product Category" : "Create Category"}
          </h6>
          <Breadcrumb
            breadCrumbParent={"Home"}
            breadCrumbActive={
              isEditMode == "edit"
                ? "Edit Product Category"
                : "Create Product Category"
            }
            breadCrumbParent2={"Product Category"}
            breadCrumbTitleKey={"/"}
            classes=""
          />
        </div>
      </div>
      <div className="bg-white shadow-md rounded-lg p-6">
        <Formik
          initialValues={{
            categoryName: isEditMode === "edit" ? categoryData?.name || "" : "",
          }}
          validationSchema={Yup.object({
            categoryName: Yup.string()
              .trim()
              .nullable()
              .required("Please enter category name"),
          })}
          onSubmit={(values) => {
            setFormValues(values);
            setShowConfirmationModal(true);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
          }) => (
            <Form onSubmit={handleSubmit}>
              <div className="grid mb-6">
                {/* Category Name */}
                <InputWithLabel
                  idFromName="categoryName"
                  label="Category Name*"
                  type="text"
                  onChange={(e) => {
                    handleChange(e);
                    setIsDisable(false);
                  }}
                  onBlur={handleBlur}
                  value={values.categoryName}
                  errors={errors.categoryName && touched.categoryName}
                  errorsText={errors.categoryName}
                  disabled={isEditMode === "edit" && !isEditing}
                  className={`${
                    isEditMode === "edit" && !isEditing
                      ? "text-textGrey border border-dashed "
                      : "text-black border hover:border-themeBtn"
                  }  ${
                    errors.categoryName && touched.categoryName
                      ? `border border-red`
                      : `border border-borderTheme/80 focus-within:border-themeBtn `
                  }  transition duration-300 ease-in-out`}
                />
              </div>

              {/* Submit Button */}
              <div className="flex justify-end gap-3 mt-3">
                <DefaultPrimaryButton
                  type="button"
                  value="Cancel"
                  onClick={() => navigate(-1)}
                />
                {isEditMode === "edit" ? (
                  isEditing ? (
                    <>
                      <div className="flex gap-2">
                        <DefaultButton type="submit" value="Confirm" />
                      </div>
                    </>
                  ) : (
                    <DefaultButton
                      value="Edit"
                      onClick={handleEditClick}
                      type="submit"
                    />
                  )
                ) : (
                  <DefaultButton
                    type="submit"
                    value="Create"
                    disabled={isDisable}
                  />
                )}
              </div>
            </Form>
          )}
        </Formik>
      </div>
      {showConfirmationModal && (
        <div>
          <ConfirmationModel
            confirmText={isEditMode === "edit" ? "Edit" : "Create"}
            onClose={() => setShowConfirmationModal(false)}
            onConfirm={() => handleConfirm()}
            isLoading={isLoading}
          />
        </div>
      )}
    </>
  );
};

export default CreateEditCategory;
